<template>



<ContactForm></ContactForm>
</template>

<script>

import ContactForm from '@/components/ContactForm.vue'

export default {
  name: 'Contacto',
  components: {
    ContactForm
  }
}
</script>


